import React from "react"
import styled from "styled-components"
import { colors } from "../../../common/colors/app_colors"
import { makeToast } from "../../../util/toast_util"
const { iconGray } = colors

const TrashButton = ({ handleClick }) => {
    return (
        <div className="trash-button" onClick={handleClick}>
            <i className="fa fa-trash-o" aria-hidden="true"></i>
            <span>Delete configuration</span>
        </div>
    )
}
export const ZoomConfigForm = ({
    config,
    handleDeleteConfig,
}) => {
    const { id, zoomAccountEmail } = config

    const handleDelete = () => {
        const toastMsg = `Are you sure you want to delete this Zoom Configuration? Time records will no longer be created automatically based on this config.`
        const deleteConfig = () => {
            handleDeleteConfig(id)
        }
        const action = {
            text: "YES",
            onClick: deleteConfig,
        }
        makeToast(toastMsg, "danger", action)
    }

    return (
        <ConfigFormWrapper>
            <div>Connected to Zoom Account <b>{zoomAccountEmail}</b>.</div>
            <TrashButton handleClick={handleDelete} />
        </ConfigFormWrapper>
    )
}

const ConfigFormWrapper = styled.div`
    width: 100%;
    .final-row {
        display: flex;
        justify-content: space-between;
    }
    .trash-button {
        font-size: 24px;
        cursor: pointer;
        i {
            margin-left: -3px;
            color: ${iconGray};
        }
        :hover {
            color: black;
        }
        span {
            font-family: inherit;
            font-size: 14px;
            font-weight: 600;
            padding-left: 8px;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/zoom/zoom_config_form.jsx